// extracted by mini-css-extract-plugin
export default {"square":"fd4237c82b19ba0e5a15"};